// ---------------------------------------------------------------------------
// Barra de cima do app no celular (telas principais): logo à esquerda, "Eu"
// (abre Meu perfil) e ☰ (abre o menu) à direita. Some no computador (lá fica o
// menu de cima do site) e nas telas internas (que têm o próprio cabeçalho).
// ---------------------------------------------------------------------------
import { Link, useLocation } from 'react-router-dom';
import Logo from '@/components/ui/Logo';
import AvatarPessoa from '@/components/ui/AvatarPessoa';
import { useMenuApp } from './MenuApp';

// Telas principais do app (não têm cabeçalho próprio). A Início cuida da
// própria linha (saudação + Eu + ☰), por isso não entra aqui.
const PRINCIPAIS = new Set([
  '/agenda',
  '/minhas-inscricoes',
  '/meus-ingressos',
  '/minhas-fichas',
  '/minhas-rifas',
  '/meu-perfil',
  '/convites',
]);

export default function BarraApp() {
  const { pathname } = useLocation();
  const { abrir, logado, naoLidos } = useMenuApp();

  if (!PRINCIPAIS.has(pathname)) return null;

  return (
    <header className="sticky top-0 z-30 border-b border-background-200/70 bg-background-100/95 backdrop-blur-md md:hidden">
      <div className="mx-auto flex h-14 w-full max-w-[720px] items-center gap-2 px-4">
        <Link to="/" className="flex min-w-0 flex-1 cursor-pointer items-center" aria-label="Se Liga">
          <Logo imgClassName="h-8 w-auto object-contain" />
        </Link>

        <Link
          to={logado ? '/meu-perfil' : '/entrar'}
          aria-label="Eu"
          className="aperta flex shrink-0 cursor-pointer items-center justify-center"
        >
          <AvatarPessoa tamanho={40} textoClassName="text-[14px]" />
        </Link>

        <button
          type="button"
          onClick={abrir}
          aria-label="Menu"
          className="aperta relative flex h-10 w-10 shrink-0 cursor-pointer items-center justify-center rounded-full text-foreground-800 hover:bg-background-200/60"
        >
          <i className="ri-menu-line text-[22px]" aria-hidden />
          {naoLidos > 0 && (
            <span className="absolute right-1.5 top-1.5 h-2.5 w-2.5 rounded-full bg-accent-500 ring-2 ring-background-100" />
          )}
        </button>
      </div>
    </header>
  );
}